import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CLINIC_INFO } from '../utils/constants';
import './Header.css';
import logo from './bkdental_logo_new.png';

const Header = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const isActive = (path) => location.pathname === path ? 'active' : '';

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const handleCall = () => {
    window.location.href = 'tel:0714680485';
    closeMenu();
  };

  const handleAppointment = () => {
    window.open('https://wa.me/+94714680485?text=Hi%20I%20would%20like%20to%20book%20an%20appointment', '_blank');
    closeMenu();
  };

  return (
    <header className="header-main">
      <div className="header-container">
        
        {/* LOGO SECTION */}
        <div className="header-logo">
          <img 
            src={logo}
            alt="Bokundara Logo" 
            className="logo-image"
          />
          {/* <span className="logo-text">Bokundara</span> */}
        </div>

        {/* HAMBURGER MENU - Mobile Only */}
        <button
          className={`hamburger-menu ${menuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>

        {/* NAVIGATION MENU */}
        <nav className={`header-nav ${menuOpen ? 'open' : ''}`}>
          <ul className="nav-list">
            <li className="nav-item">
              <Link 
                to="/" 
                className={`nav-link ${isActive('/')}`}
                onClick={closeMenu}
              >
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/about" 
                className={`nav-link ${isActive('/about')}`}
                onClick={closeMenu}
              >
                About Us
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/services" 
                className={`nav-link ${isActive('/services')}`}
                onClick={closeMenu}
              >
                Services
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/gallery" 
                className={`nav-link ${isActive('/gallery')}`}
                onClick={closeMenu}
              >
                Gallery
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/contact" 
                className={`nav-link ${isActive('/contact')}`}
                onClick={closeMenu}
              >
                Contact
              </Link>
            </li>
          </ul>

          {/* MOBILE ACTION BUTTONS - Inside Menu */}
          <div className="nav-actions-mobile">
            <button 
              className="nav-btn nav-appointment-btn"
              onClick={handleAppointment}
            >
              📅 Make an Appointment
            </button>
            <button 
              className="nav-btn nav-call-btn"
              onClick={handleCall}
            >
              ☎️ Call Now
            </button>
          </div>
        </nav>

        {/* DESKTOP ACTION BUTTONS */}
        <div className="header-actions">
          <button 
            className="btn-appointment"
            onClick={handleAppointment}
          >
            📅 Make an Appointment
          </button>
          <button 
            className="btn-call-now"
            onClick={handleCall}
          >
            ☎️ Call Now
          </button>
        </div>

        {/* MENU OVERLAY - Click to close menu */}
        {menuOpen && (
          <div 
            className="menu-overlay"
            onClick={closeMenu}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Escape') closeMenu();
            }}
            aria-label="Close menu"
          ></div>
        )}
      </div>
    </header>
  );
};

export default Header;
